// 通用方法
import commons from "./common";
import {getBtn} from "./btnAuth";
import {getUser} from "./user";
import common from "./common";
import {getRegion, getRegionOptions, regionKey, setRegion} from "./region";
import { mapGetters } from "vuex";

export const mixins = {
  data(){
    return {
      languageId:1,
      languageOptions:[
        {
          id: 1,
          name: '简体中文'
        },{
          id: 2,
          name: 'English'
        },
      ],
      operateTip:'操作成功!',
      userInfo: '',
      regionOptions: getRegionOptions(),
      pickerOptions: {
        disabledDate(time) {
          // 获取今天的23:59:59
          const endOfDay = new Date();
          endOfDay.setHours(23, 59, 59, 999);
          // 如果时间在今天之前或者在今天的23:59:59之后，则禁用
          return (time.getTime() > endOfDay.getTime());
        }
      },
      amountStyle: {
        billAmount: '#409EFF', /* 账单金额 */
        discount: '#20B2AA', /* 折扣 */
        cdnDiscount: '#20B2AA', /* CDN 折扣 */
        cdnAmount: '#FF8C52', /* CDN 金额 */
        support: '#FF8C52', /* Support 金额 */
        actualPaid: '#FF4D4F',  /* 实付金额 */
        prepaid: '#FF69B4', /* 预付金额 */
      }
    }
  },
  computed: {
    // 获取store的getter
    regionCode (){
      return this.$store.getters.region
    },
    // 财务账单状态
    financeEnableType() {
      return [
        {name: this.isZh ? '编辑中' : 'Editing', class: 'update_active'},
        {name: this.isZh ? '已收款' : 'Received payment', class: 'normal'},
        {name: this.isZh ? '待审核' : 'Audit', class: 'await'},
        {name: this.isZh ? '已审核' : 'Audited', class: 'normal'},
      ]
    },
    messageTypes() {
      return {
       1: this.isZh ? '账单告警' : 'Bill alarm',
       2: this.isZh ? '账号安全' : 'Account security',
       3: this.isZh ? '账号冻结' : 'Account freeze',
       4: this.isZh ? '账号注销' : 'Account cancellation',
      }
    },
    payOptions() {
      return {
        // 0:this.isZh ? '账单组账单' : 'Bill Group Bill',
        // 1:this.isZh?'月度费用':'Monthly expenses',
        // 2:this.isZh?'账号折扣':'Account discount',
        // 3:this.isZh?'CDN协议':'CDN protocol'
        0: this.isZh? '预付客户' : 'Prepaid customer',
        1: this.isZh ? '后付客户' : 'Postpaid customer',
        2: this.isZh ? '电汇客户' : 'Telegraphic transfer customer',
      }
    },
    sendTypes() {
      return [this.isZh ? '系统自动发送' : 'System automatically sends', this.isZh ? '手动发送' : 'Manual sending']
    },
    sendStatus() {
      return [this.isZh ? '未发送' : 'Not sent', this.isZh ? '已发送' : 'Sent']
    },
    staffTypeOptions() {
      return {
        1: this.isZh ? '管理员' : 'Administrator',
        2: this.isZh ? '财务' : 'Finance',
        3: this.isZh ? '技术' : 'Technical',
        4: this.isZh ? '销售' : 'Sales',
        5: this.isZh ? '普通员工' : 'General employee',
        6: this.isZh ? '运营' : 'Operator',
      }
    },
    unitTypes(){
      // const isZh = this.isZh;
      const isZh = false;
      return {0: isZh ? '美元' : 'USD',1: isZh ? '人民币' : 'CNY'}
    },
    convertRmbTypes(){
      return {0: this.isZh ? '不转换' : 'Do not convert',1: this.isZh ? '美元转人民币' : 'USD to RMB conversion'}
    },
    // 是否中文
    isZh() {
      return this.languageId===1;
    },
    companyOptions() {
      return {
        0: this.isZh?'系统公司':'System company',
        1: this.isZh ? '客户公司' : 'Customer ownerTypes',
      }
    },
    // 类型(默认0:aws服务,1:系统服务)
    serverTypeOptions() {
      return ['AWS '+this.$t('common.service'), this.$t('common.system')+this.$t('common.service'), ]
    },
    // 根据系统选择的区域变化返回对应区域的货币单位
    getCurrencyByRegion() {
      let region = this.regionCode;
      let currency = {
        name: '',
        unit: ''
      };
      // 海外区
      if (region === 'us-east-1') {
        currency = {
          name: 'USD',
          unit: '$'
        };
      }
      // 中国区
      if (region === 'cn-northwest-1') {
        currency = {
          name: 'CNY',
          unit: '¥'
        }
      }
      return currency;
    }
  },
  mounted() {
    let that = this;
    that.userInfo = getUser() ? JSON.parse(getUser()) : '';
    that.languageId = localStorage.getItem('lang') === 'en' ? 2 : 1;
    // 监听语言缓存
    window.addEventListener("setItemEvent", function (e) {
      // 表格行乱码调整
      that.$nextTick(() => {
          if (that.$refs.multipleTable) {
            that.$refs.multipleTable.doLayout();
          }
        })
      if (e.key === 'lang') {
        that.languageId = e.newValue === 'en' ? 2 : 1;
        that.$store.commit('SET_LANGUAGE', this.languageId)
        that.operateTip =  e.newValue === 'en' ? 'Operation successful!':'操作成功!';
      }
      if (e.key === regionKey) {
        that.$store.commit('SET_REGION_CODE', e.newValue)
      }
    });
  },

  methods:{
    uploadLanguage(id){
      let lang = id === 1 ? 'zh':'en';
      this.$i18n.locale = lang;
      // localStorage.setItem('lang', lang);
      this.$localStorage.lang = lang;
    },
    /**
     * 监听语言缓存选中变更,执行传入的函数
     * @param fun 变更后要执行的函数
     */
    listenToLocalStorageByLanguage(fun) {
      this.handleLanguageChange = (e) => {
        if (e.key === 'lang') {
          fun && fun(); // 传入参数1
        }
      }
      // 监听语言缓存
      window.addEventListener("setItemEvent", this.handleLanguageChange);
    },
    uploadRegion(id){
      setRegion(id)
    },

    resetImageUrl(url){
      return url.replace(/sflows/g, 'zeeduu')
    },

    // 设置table标题居中
    tableHeader({row, column, rowIndex, columnIndex}) {
      return 'background:#F0F2F5;color:#111;padding:3px 0!important;font-size:14px;font-weight:600'
    },

    otherHeader({row, column, rowIndex, columnIndex}) {
      return 'background:#F0F2F5;color:#111;padding:10px 0!important;font-size:14px;font-weight:600'
    },

    /**
     * 获取页面权限
     * @param code 列表的code，类似以前的query
     * @param isRequest 是否请求
     */
    // getPageLimit(code, isRequest = true){
    //   const uniqueCode = this.$router.currentRoute.query.key || ''
    //   getBtn(code,uniqueCode).then(res=>{
    //     this.btn = res;
    //     if ((code && this.btn[code]) || !code) {
    //       isRequest && this.getTableInfo(1);
    //     }
    //   })
    // },
    /**
     * 获取页面权限
     * @param code 列表的code，类似以前的query
     * @param isRequest 是否请求
     */
    getPageLimit(code, isRequest = true){
      this.btn = this.$store.state.btnAuth
      if (code && this.btn[code] || !code) {
        isRequest && this.getTableInfo(1);
      } else {
        console.error(this.$store.state.btnAuth,this.btn,code);
        // location.href = '/errorPage';
      }
    },
    /**
     * 获取页面权限
     * @param code 列表的code，类似以前的query
     * @param callback 回调函数
     */
    getPageAuth(code, callback){
      this.btn = this.$store.state.btnAuth
      if (code && this.btn[code] || !code) {
        callback && callback()
      } else {
      console.error('this.btn',this.btn,code, callback);

        // location.href = '/errorPage';
      }
    },
    // table页码修改
    sizeChange(val) {
      this.pageSize = val;
      this.getTableInfo(1);
    },

    // 列表索引
    indexMethod(index) {
      return this.currentPage > 1 ? ((this.currentPage-1) * this.pageSize + index + 1) : +index + 1;
    },

    // 时间格式化
    formatTime(time) {
      return commons.formatTime(time)
    },

    // 格式化日期
    formatDate(time) {
      return commons.formatTime(time).split(' ')[0]
    },

    // 首字母大写转换
    capitalizeFirstLetter(string) {
      return commons.capitalizeFirstLetter(string)
    },

    // 打开图片
    openImg(url) {
      this.isOpen = true;
      this.icon = url;
    },

    // 提示设置
    setTip(num, text) {
      this.tipNum = num;
      this.infoTip = text;
    },

    // 编辑提示
    setResult(finish) {
      if (finish) {
        this.closePopup(true);
        this.$message.success({
            message: this.$t('btn.success'),
            duration: 1000,
            showClose: true
          });
      }
      this.loading = false;
    },

    // 监听弹窗
    listenToEdit(e){
      this.isPop = false;
      if (e.refresh){
        this.getTableInfo(this.currentPage);
      }
    },

    // 关闭
    closePopup(refresh) {
      this.$emit('listenToChild', {refresh: refresh})
    },

    // 状态显示
    currentStatus(options,current){
      return options.filter(item => item.id === current);
    },

    // 下载Excel
    downloadExcel(data,name, type='csv') {
      const link = document.createElement('a');
      let blob = new Blob([data], {type: 'application/vnd.ms-excel'});
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      link.download = `${name}.${type}`; //下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    /**
     * 回显勾选项
     * @param arr 源数据
     * @param refName ref名称
     */
    formatIds(arr,refName='multipleTable') {
      let that = this;
      if (that.selectArr.length) {
        that.selectArr.forEach((uniqueCode) => {
          arr.forEach((item) => {
            if (item.uniqueCode === uniqueCode) {
              that.$refs[refName].toggleRowSelection(item);
            }
          })
        })
      }
    },

    // 批量勾选
    resetSelect(data) {
      let that = this;
      //清空当前页的全部id
      that.tableInfo.forEach((item)=> {
        that.selectArr.forEach((items,i)=> {
          if(item.uniqueCode === items) {
            that.selectArr.splice(i,1)
          }
        })
      })
      //获取当前页选中的ids
      let selectOption = []
      data.forEach((item, i) => {
        selectOption.push(item.uniqueCode)
      });
      // 更新selectArr
      that.selectArr = that.selectArr.concat(selectOption)
    },

    // 价格格式化
    priceToFixed(num,precision = 2,isFill=true) {
      return common.priceToFixed(num,precision,isFill)
    },

    /**
     * 手动设置多选下拉的高度
     * @param ref 选择器ref名称
     * @param keyName 高度存储的key
     * @param isFilterable 是否可以搜索
     */
    setMultipleSelectHeight(ref,keyName,isFilterable=false) {
      const that = this
      if (that.$refs[ref] && that.$refs[ref].$el.querySelector('.el-select__tags')) {
        that.$nextTick(() => {
          try {
            // 获取选择器的高度
            const selectHeight = that.$refs[ref].$el.querySelector('.el-select__tags').offsetHeight
            that.$set(that, keyName, Number(selectHeight + 2))
          } catch (e) {
            console.error(e)
            that.$set(that, keyName, 40)
          }
        })
      } else {
        that[keyName] = 40
      }
    },

    /**
     * 校验值是否为数字，并且 小于或等于 最大值 ，大于或等于 最小，符合预设步长
     * @param newVal
     * @param max
     * @param min
     * @param precision
     * @return {number|''}
     */
    setVerifyNumbers(newVal,min=0,max=Infinity,precision=1) {
      if (typeof newVal !== 'number') {
        return '';
      } else {
        newVal = this.toPrecision(newVal, precision);
      }
      if (newVal >= max) newVal = max;
      if (newVal <= min) newVal = min;
      return newVal;
    },
    /**
     * 校验步长，默认1
     * @param num
     * @param precision
     * @return {number}
     */
    toPrecision(num, precision) {
      if (precision === undefined) precision = 1;
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    /**
     * 判断数字
     * @param value 判断数字
     */
    checkNumber(value) {
      const isNum = /^-?\d+(\.\d+)?$/ // 判断是否都为数字，可包含'.', '-'
      if ((!value && value !== 0) || !isNum.test(value) || (Number(value) < 0)) {
        return '';
      }
      return value;
    },
    /**
     * 获取指定月份的第一天和最后一天
     * 默认获取当前月份的第一天和当前日期的数组
     * @param month 指定月份格式为yyyy-MM，不传默认返回当月
     * @returns {Array} 月份的第一天和最后一天(若月份为当前月份，则最后一天为当前日期)的数组，格式为yyyy-MM-dd
     */
    getDateArray(month = new Date()) {
      let result = [];
      let date = new Date(month); // 使用传入的月份参数，如果没有传入则使用当前日期

      // 获取指定月份的第一天
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      result.push(this.formatDate(firstDay));

      // 获取指定月份的最后一天
      let lastDay;
      if (date.getFullYear() === new Date().getFullYear() && date.getMonth() === new Date().getMonth()) {
        lastDay = new Date(); // 若月份为当前月份，则最后一天为当前日期
      } else {
        lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      }
      result.push(this.formatDate(lastDay));
      return result;
    },

    /**
     * 收起所有展开行,后查询
     * @param {Array} expandRows - 当前展开的行数据的index
     */
    collapseAllRows(expandRows= []) {
      if (expandRows.length) {
        // 获取表格实例
        const table = this.$refs.multipleTable;
        // 获取当前展开的行
        const expandedRows = this.tableInfo.filter(row => expandRows.includes(row.index));
        // 循环收起所有展开的行
        expandedRows.forEach(row => {
          table.toggleRowExpansion(row);
        });
      }
    },

    getPageKey() {
      let href = window.location.href;
      let start = href.indexOf('=') + 1;
      let end = href.indexOf('&') !== -1 ? href.indexOf('&') : href.length;
      let index = href.substring(start, end);
      return index;
    },

    /**
     * 传入字段数组、判断字段是否存在，存在返回false，不存在返回true
     * 勾选了表示隐藏，不勾选默认显示
     * 存在就要返回false，不存在返回true
     * @param {Array} arr - 传入的字段数组
     * @param {String} field - 要判断的字段
     * @returns {Boolean} - 存在返回false，不存在返回true
     */
    isFieldExist(arr, field) {
      if (Array.isArray(arr) && arr.length) {
        return !arr.some(item => item.displayField === field);
      }
      return true;
    }

  },
  // 在组件销毁时执行以下代码
  beforeDestroy() {
    if (this.handleLanguageChange) {
      window.removeEventListener("setItemEvent", this.handleLanguageChange); // 取消监听事件
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/mixins.js